import React from 'react';
import PropTypes from 'prop-types';
import { message, Modal, Typography } from 'antd';
import { FullValidationErrorFragment } from '@common/graphql/fragments';
import { gql, useMutation } from '@common/hooks';
import { Gutter, Icon } from '@common/components';

const { Text } = Typography;

const RemoveTermMutation = gql`
  mutation VoidAssignmentTerm($assignmentTermId: ID!) {
    voidAssignmentTerm(assignmentTermId: $assignmentTermId) {
      assignmentTerm {
        id
      }
      errors {
        ...FullValidationErrorFragment
      }
    }
  }
  ${FullValidationErrorFragment}
`;

export function RemoveTerm({ assignmentTermId, showModal, onClose }) {
  const [removeTerm] = useMutation(RemoveTermMutation, {
    variables: { assignmentTermId },
    onCompleted: (response) => {
      if (response?.voidAssignmentTerm.errors) {
        const errorMessage = response.voidAssignmentTerm.errors[0].errors[0];
        message.error(`Error: ${errorMessage}`);
      } else {
        message.success('Term successfully removed');
        onClose();
      }
    },
    onError: () => message.error('An error has occurred. Try again later.'),
    refetchQueries: ['CandidateAssignmentQuery'],
  });

  return (
    <>
      <Modal
        className="RemoveTermModal"
        title={
          <>
            <Gutter direction="right" fit>
              <Icon
                icon="trash"
                kind="regular"
                size="md"
                color="coral"
                className="remove-icon"
              />
            </Gutter>
            <Text strong>Confirm you&apos;d like to remove this term</Text>
          </>
        }
        visible={showModal}
        onCancel={onClose}
        onOk={removeTerm}
        okText="Remove"
        closable={false}
      >
        <p className="remove-term-description">
          Removing a term is not the same as canceling an assignment. If you
          need to indicate a termination, use Cancel Assignment.
        </p>
      </Modal>
      <style jsx>{`
        :global(.RemoveTermModal .ant-modal-footer) {
          text-align: right;
        }
        .remove-term-description {
          margin-bottom: 0;
        }
      `}</style>
    </>
  );
}

RemoveTerm.propTypes = {
  assignmentTermId: PropTypes.string.isRequired,
  showModal: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
